import { useNavigate } from "react-router-dom"
import { app, translate } from "../app"
import { languages } from "../locale"
import { ImageWithFallback } from "./image"
import { useAnimateOnScroll } from "./useAnimateOnScroll"
import { SplitText } from "./splittext"
import { Search } from "./searchinput"

export function BlockMission(props: { block: BlockMission }) {
  const { block } = props
  const navigate = useNavigate()
  const locale = languages[app.locale]?.zendesk as string ?? app.locale
  const isRTL = languages[app.locale]?.rtl
  useAnimateOnScroll()

  const handleSearch = (value: string) => {
    navigate(`/${locale.toLowerCase()}/search-results?query=${value}`)
  }

  return <div className="w-full">
    <div className="fade-up-0 block-mission-background" data-animation="animate__fadeInUp">
      <ImageWithFallback filename={block.image} alt={translate(block.title)} className="absolute inset-0 w-full h-full object-cover -z-10" />
      <div className="max-w-4xl mx-auto container-center px-4 sm:px-6 md:px-8">
        <h1 className={`font-medium mission-heading ${isRTL ? 'text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
          <SplitText text={translate(block.title)} />
        </h1>
        <div className={`mt-2 ${isRTL ? 'rtl' : ''} w-full`}>
          <Search
            blueButton
            onSearch={handleSearch}
            isRtl={isRTL}
            aria-label="Submit"
          />
        </div>
      </div>
    </div>
  </div>
} 